import api from './api';

export const obtenerAsociadoPorId = async (id) => {
    const response = await api.get(`/asociados/${id}`);
    return response.data;
};

export const obtenerPlanVigentePorAsociado = async (id) => {
    const response = await api.get(`/asociados/${id}/plan-vigente`);
    return response.data;
};
